import React from 'react';
import { Link } from 'react-router-dom'
import Bg from '../../../images/backgrounds/bg_image_2.webp'
import Bg2 from '../../../images/shapes/shape_bg_1.webp'
import Bg3 from '../../../images/shapes/shape_title_under_line.svg'
import about1 from '../../../images/about/about_it_services_396x480.png'
import aIcon1 from '../../../images/avatar/avatar_1.webp'
import aIcon2 from '../../../images/avatar/avatar_2.webp'
import aIcon3 from '../../../images/avatar/avatar_3.webp'
import aIcon4 from '../../../images/icons/icon_global.svg'
import aIcon5 from '../../../images/shapes/shape_line.webp'
import shape1 from '../../../images/shapes/shape_space_2.svg'


const About = (props) => {

  return (
    <section className="about_and_case_section section_space section_decoration bg-dark" style={{ backgroundImage: `url(${Bg})` }}>
      <div className="container">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-7 order-lg-last">
            <div className="about_image_2">
              <div className="image_wrap">
                <img src={about1} alt="Krit Cloud Platforms team reviewing cloud infrastructure dashboards" />
              </div>
              <div className="about_funfact_info" style={{ backgroundImage: `url(${Bg2})` }}>
                <div className="customer_count">
                  <ul className="unordered_list">
                    <li>
                      <img src={aIcon1} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={aIcon2} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={aIcon3} alt="Customer Avatar" />
                    </li>
                    <li>
                      <span>6k+</span>
                    </li>
                  </ul>
                  <p className="mb-0">
                    Supported Teams
                  </p>
                </div>
                <div className="about_funfact_counter">
                  <div className="funfact_item">
                    <div className="counter_value">
                      <span className="odometer" data-count="10">0</span>
                      <span>+</span>
                    </div>
                    <h3 className="funfact_title mb-0">Core Services</h3>
                  </div>
                  <div className="funfact_item">
                    <div className="counter_value">
                      <span className="odometer" data-count="100">0</span>
                      <span>%</span>
                    </div>
                    <h3 className="funfact_title mb-0">Business Focused</h3>
                  </div>
                </div>
                <Link className="btn btn-primary" to="/contact">
                  <span className="btn_label" data-text="Talk to Us">Talk to Us</span>
                  <span className="btn_icon">
                    <i className="fa-solid fa-arrow-up-right"></i>
                  </span>
                </Link>
                <div className="icon_globe">
                  <img src={aIcon4} alt="Icon Globe" />
                </div>
              </div>
              <div className="space_line">
                <img src={aIcon5} alt="Shape Line" />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="about_content">
              <div className="heading_block mb-0 text-white">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
                  Why Choose Us
                </div>
                <h2 className="heading_text">
                  Practical IT Solutions That <mark>Move Work Forward</mark>
                </h2>
                <p className="heading_description">
                  Krit Cloud Platforms Sdn Bhd helps businesses modernize with clear planning, secure implementation and dependable support. We focus on useful systems, not unnecessary complexity.
                </p>
                <ul className="icon_list unordered_list_block mt-4">
                  <li>
                    <span className="icon_list_icon">
                      <i className="fa-regular fa-circle-dot"></i>
                    </span>
                    <span className="icon_list_text">High-level IT services across cloud, software, data, security and automation.</span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <i className="fa-regular fa-circle-dot"></i>
                    </span>
                    <span className="icon_list_text">Solutions shaped around real business workflows and user adoption.</span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <i className="fa-regular fa-circle-dot"></i>
                    </span>
                    <span className="icon_list_text">Ongoing maintenance, improvement and technical guidance after launch.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="decoration_item shape_image_1">
        <img src={shape1} alt="Krit Shape" />
      </div>
    </section>
  )
}

export default About;
